import { useGetAdminBoardCardConfigQuery } from '../../__generated__/chirp/com/hubspot/crm/pipeline/board/configuration/rpc/CrmPipelineBoardConfigurationService.hooks';
import { useEffect, useMemo } from 'react';
import { useUpdateSettings } from '../settings/store/slice/sectionSettingsActions';
import { getFormattedSectionSettings } from './utils';
import { useIsAdminView } from '../providers/settings/CardSettingsPanelProvider';
import { useBoardCardSectionSettings } from '../hooks/useBoardCardSectionSettings';
// Fetch settings from user customizations stored in DB
export const useCardSectionSettings = ({
  skip,
  pipelineId,
  objectTypeId,
  appId,
  isAdminView
}) => {
  // use preloaded state for user's customizations
  const userData = useBoardCardSectionSettings();
  // load admin customizations if isAdminView is true
  const {
    loading: adminLoading,
    error: adminError,
    data: adminApiData
  } = useGetAdminBoardCardConfigQuery({
    skip: skip || !isAdminView,
    variables: {
      pipelineId,
      objectTypeId,
      appId
    }
  });
  const apiData = isAdminView ? adminApiData === null || adminApiData === void 0 ? void 0 : adminApiData.boardCardSectionConfigurations : userData;
  const loading = adminLoading;
  const error = adminError;
  const formattedSettings = useMemo(() => {
    return getFormattedSectionSettings(apiData !== null && apiData !== void 0 ? apiData : []);
  }, [apiData]);
  return {
    loading,
    error,
    data: formattedSettings
  };
};

// Set redux store after successful fetch
export const useCardSectionSettingsWithStore = ({
  skip,
  pipelineId,
  objectTypeId,
  appId
}) => {
  const updateSectionSettingsStore = useUpdateSettings();
  const isAdminView = useIsAdminView();
  const {
    loading,
    error,
    data
  } = useCardSectionSettings({
    skip,
    pipelineId,
    objectTypeId,
    appId,
    isAdminView
  });
  useEffect(() => {
    if (data) {
      updateSectionSettingsStore(data);
    }
  }, [updateSectionSettingsStore, data]);
  return {
    loading,
    error,
    data
  };
};